<form
  class="form-group odd"
  id="expense_name_field_box"
  [formGroup]="expenseForm"
>
  <label
    class="col-sm-3 control-label"
    for="name"
    id="expense_name_display_as_box"
  >
    <font style="vertical-align: inherit">
      <font style="vertical-align: inherit">
        {{ expenseI18n.nameI18n }}
      </font> </font
    ><span class="required">
      <font style="vertical-align: inherit">
        <font style="vertical-align: inherit">*</font>
      </font>
    </span>
  </label>
  <div class="col-sm-9 col-md-6 col-lg-6" id="expense_name_input_box">
    <!-- expense text field-->
    <input
      [ngClass]="{ 'is-invalid': submitted && f.name.errors }"
      formControlName="name"
      id="field-expense_name"
      name="name"
      class="form-control"
      type="text"
      maxlength="99"
    />
    <!-- expense Validation message -->
    <div *ngIf="submitted && f.name.errors" class="alert alert-danger">
      <div *ngIf="submitted && f.name.errors.required">
        {{ msg.validationMessage.name }}
      </div>
    </div>
  </div>

  <label
    class="col-sm-3 control-label"
    for="name"
    id="expense_name_display_as_box"
  >
    <font style="vertical-align: inherit">
      <font style="vertical-align: inherit">
        {{ expenseI18n.dateI18n }}
      </font> </font
    ><span class="required">
      <font style="vertical-align: inherit">
        <font style="vertical-align: inherit">*</font>
      </font>
    </span>
  </label>
  <div class="col-sm-9 col-md-6 col-lg-6" id="expense_name_input_box">
    <!-- expense text field-->
    <input
      [ngClass]="{ 'is-invalid': submitted && f.date.errors }"
      formControlName="date"
      id="field-expense_name"
      name="date"
      class="form-control"
      type="date"
      maxlength="99"
    />
    <!-- expense Validation message -->
    <div *ngIf="submitted && f.date.errors" class="alert alert-danger">
      <div *ngIf="submitted && f.date.errors.required">
        {{ msg.validationMessage.date }}
      </div>
    </div>
  </div>

  <label
    class="col-sm-3 control-label"
    for="name"
    id="expense_name_display_as_box"
  >
    <font style="vertical-align: inherit">
      <font style="vertical-align: inherit">
        {{ expenseI18n.amountI18n }}
      </font> </font
    ><span class="required">
      <font style="vertical-align: inherit">
        <font style="vertical-align: inherit">*</font>
      </font>
    </span>
  </label>
  <div class="col-sm-9 col-md-6 col-lg-6" id="expense_name_input_box">
    <!-- expense text field-->
    <input
      [ngClass]="{ 'is-invalid': submitted && f.amount.errors }"
      formControlName="amount"
      id="field-expense_name"
      name="amount"
      class="form-control"
      type="text"
      maxlength="99"
    />
    <!-- expense Validation message -->
    <div *ngIf="submitted && f.amount.errors" class="alert alert-danger">
      <div *ngIf="submitted && f.amount.errors.required">
        {{ msg.validationMessage.amount }}
      </div>
    </div>
  </div>
  <label
    class="col-sm-3 control-label"
    for="name"
    id="expense_name_display_as_box"
  >
    <font style="vertical-align: inherit">
      <font style="vertical-align: inherit">
        {{ expenseI18n.noteI18n }}
      </font> </font
    ><span class="required">
      <font style="vertical-align: inherit">
        <font style="vertical-align: inherit">*</font>
      </font>
    </span>
  </label>
  <div class="col-sm-9 col-md-6 col-lg-6" id="expense_name_input_box">
    <!-- expense text field-->
    <textarea
      formControlName="note"
      id="field-expense_name"
      name="note"
      class="form-control"
      type="text"
      maxlength="99"
    ></textarea>
    <!-- expense Validation message -->
  </div>
  <!-- submit button -->
  <br />
  <button (click)="add()" type="button" class="btn btn-info">
    <i class="fas fa-save"></i>
    {{ expenseI18n.addButtonI18n }}
  </button>
</form>
